exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2{text-align:center}h3{text-decoration:underline}#header,h3{font-weight:700;padding-left:1.5rem;font-family:Verdana,Tahoma,Arial}#header{font-size:10pt}h4{font-weight:700;text-decoration:underline}h4,p{padding-left:1.5rem;font-family:Verdana,Tahoma,Arial}p{font-size:10pt}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/sortTaskListHelp/sortTaskListHelp.component.scss
// module id = ./src/app/sortTaskListHelp/sortTaskListHelp.component.scss
// module chunks = app